export enum CrmOwnedContactsStatusEnum {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}
